// SoloPriceEntry.tsx - the dual price-number entry (locked DX7). Training wheels off: unlike Diagnose,
// which SHOWS the price with a fading math aid, Solo shows NOTHING. You get the pot and his bet, and you
// type both numbers yourself - the dollars to call and the equity you need. The action buttons stay gated
// until BOTH are filled (the gate lives in <SoloStage>). This is the do-your-own-math principle at its
// strictest (North Star §4.2). Revealed only after the read is locked. Ported from the mockup
// #so-pricesec / the so-call / so-pct inputs.
export interface SoloPriceEntryProps {
  /** the pot to reason from, e.g. "$43". */
  pot: string;
  /** his bet to reason from, e.g. "$30". */
  hisBet: string;
  /** the typed "to call" dollars (raw string). */
  call: string;
  /** the typed required-equity % (raw string). */
  pct: string;
  onCall: (value: string) => void;
  onPct: (value: string) => void;
}

export function SoloPriceEntry({ pot, hisBet, call, pct, onCall, onPct }: SoloPriceEntryProps) {
  return (
    <div className="sec">
      <div className="stt-row">
        <span className="bar" />
        <div>
          <div className="stt">3. Work out the price</div>
          <div className="sd">Nothing is shown. Use the pot and his bet to fill both in yourself.</div>
        </div>
      </div>

      <div className="soloprice">
        <div className="spfacts">
          <div className="bmfact">
            <span>Pot</span>
            <b>{pot}</b>
          </div>
          <div className="bmfact">
            <span>His bet</span>
            <b>{hisBet}</b>
          </div>
        </div>

        <div className={'spfield' + (call.trim() ? ' ready' : '')}>
          <div className="lb">
            To call
            <s>what you put in to continue</s>
          </div>
          <span className="cur">$</span>
          <input
            inputMode="numeric"
            autoComplete="off"
            placeholder="0"
            value={call}
            onChange={(e) => onCall(e.target.value)}
          />
        </div>

        <div className={'spfield' + (pct.trim() ? ' ready' : '')}>
          <div className="lb">
            Equity you need
            <s>your call as a share of the final pot</s>
          </div>
          <input
            inputMode="numeric"
            autoComplete="off"
            placeholder="0"
            value={pct}
            onChange={(e) => onPct(e.target.value)}
          />
          <span className="sfx">%</span>
        </div>
      </div>
    </div>
  );
}
